import { OPERATOR_TYPES_1 } from 'dashboard/components/widgets/FilterInput/FilterOperatorTypes.js';

export const filterItems = [
  {
    attributeKey: 'action',
    attributeI18nKey: 'TYPE_OF_AUDIT_LOGS',
    inputType: 'multi_select',
    dataType: 'text',
    filterOperators: OPERATOR_TYPES_1,
    attributeModel: 'standard',
    showFilterOperator: true,
    query_operator: 'and',
    queryOperators: [
      { value: 'and', label: 'FILTER.QUERY_DROPDOWN_LABELS.AND' },
    ],
  },
];

export const filterAttributeGroups = [
  {
    name: 'Standard Filters',
    i18nGroup: 'STANDARD_FILTERS',
    attributes: [
      {
        key: 'action',
        i18nKey: 'TYPE_OF_AUDIT_LOGS',
      },
    ],
  },
];
